import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FirestoreService } from 'src/app/services/service.index';
import Swal from 'sweetalert2';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-itemsform',
  templateUrl: './itemsform.component.html',
  styleUrls: ['./itemsform.component.css']
})
export class ItemsformComponent implements OnInit {

  forma: FormGroup;

  user:any;

  selectedStatus="1";

  carsList: any = [];


  constructor(private afs: FirestoreService,
              public dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: any) {


  }

  ngOnInit(): void {

    this.user = this.afs.usersShow;

    this.afs.getCars().subscribe( cars => {

        console.log(cars);
        this.carsList = cars;

    });


    this.forma = new FormGroup({
      code: new FormControl( null, Validators.required),
      name: new FormControl(),
      description: new FormControl(),
      status: new FormControl(false),
    });

  }

  createItem(){


    if(this.forma.invalid){

      Swal.fire('Oops...', 'Item has not been registered!!!', 'error');

    }

    this.afs.createItem(this.user.companyId, this.forma.value).then(res => {



      Swal.fire('Good job!', 'Item has been registered', 'success');

      this.dialogRef.close();


    }).catch(err => {

      Swal.fire('Oops...', 'Item has not been registered! ' + err, 'error');

    });


  }

}
